export default __webpack_public_path__ + "static/media/Logo-DE.664196db.svg";